// TimelineHelper.js
// Deriva de "data" (procesos del timeline) el mapa { screen0: boolean, ... }
// de pasos habilitados, para ModalSolicitudCredito.

export const obtenerPasosHabilitados = (data) => {
  if (data === undefined || data === null || !Array.isArray(data)) {
    return {};
  }

  return data.reduce((acc, item, index) => {
    const habilitado =
      item !== undefined &&
      item !== null &&
      (item.habilitado === true || item.habilitado === "True");

    acc[`screen${index}`] = habilitado;
    return acc;
  }, {});
};
